import { BitmapText, Container, Sprite, Texture } from 'pixi.js';
import { Tween, Easing } from '@tweenjs/tween.js';
import { GameConfigs } from '../lib/globals/GameConfigs';
import { isDesktop } from 'react-device-detect';

class BonusTrigger extends Container {
	constructor() {
		super();
		// this.vc = vc;
		this.trigger = new Sprite();
		this.trigger.name = 'trigger';
		this.data = GameConfigs.bonusRoundData;
		this.total = 0;
		this.diff = 0;
		this.scaleValue = isDesktop ? 1 : 0.5;
		this.animated = false;
		this.initAssets();
	}

	initAssets() {
		this.trigger.scale.set(0);
		this.bg = new Sprite(Texture.from('bonus_trigger'));
		this.bg.anchor.set(0.5);
		this.bg.scale.set(1);
		this.amount = new BitmapText(
			window.lm['BONUS_TRIGGER_AMOUNT'].value,
			window.lm['BONUS_TRIGGER_AMOUNT'].config
		);
		this.amount.anchor.set(0.5);
		this.amount.y = -15;
		this.text = new BitmapText(
			window.lm['BONUS_TRIGGER_TEXT'].value,
			window.lm['BONUS_TRIGGER_TEXT'].config
		);
		this.text.anchor.set(0.5);
		this.text.y = 40;
		this.text.x = 5;
		this.amount.text = `+${this.total}`;
		this.trigger.x = isDesktop ? 570 : 570 / 2;
		this.trigger.y = isDesktop ? 350 : 350 / 2;
		this.addChildren();
	}

	addChildren() {
		this.trigger.addChild(this.bg);
		this.bg.addChild(this.amount);
		this.bg.addChild(this.text);
		this.addChild(this.trigger);
	}

	animate(total) {
		this.animated = true;
		this.total = total;
		this.amount.text = `+${this.total}`;
		window.sm.play({ name: 'additional_freespin_sfx' });
		this.trigger.scale.set(0);
		this.tweenbg = new Tween(this.trigger.scale)
			.to({ x: this.scaleValue, y: this.scaleValue }, 300)
			.easing(Easing.Back.Out)
			.onComplete(() => {
				this.tweenbg = new Tween(this.trigger.scale)
					.to({ x: 0, y: 0 }, 300)
					.easing(Easing.Back.In)
					.delay(700)
					.onComplete(() => {
						this.animated = false;
						this.tweenbg.stop();
						this.tweenbg = null;
						if (this.tweenAmount) {
							this.tweenAmount.stop();
							this.tweenAmount = null;
						}
					})
					.start();
			})
			.start();
		this.tweenAmount = new Tween(this.amount.scale)
			.to({ x: 1.3, y: 1.3 }, 150)
			.yoyo(true)
			.repeat(5)
			.easing(Easing.Linear.None)
			.start();
	}
}

export default BonusTrigger;
